import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import UploadIMG from "../components/uploads/UploadIMG";
import { createAndUpdateSocialConfig, getSocialConfig } from '../api/config_api';
import { urlToBlob } from '../utils/function';
import { setTimeOutSync } from '../utils/setTimeout';
import { useNavigate } from 'react-router-dom';

function SocialMedia() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);
    const [images5, setImages5] = useState([]);
    const [imagesFromApi5, setImagesFromApi5] = useState([]);

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };

    const handleSelectedImages4 = (images) => {
        setImages4(images);
    };
    const handleSelectedRemoveImg4 = (data) => {
        setImages4(data);
    };

    const handleSelectedImages5 = (images) => {
        setImages5(images);
    };
    const handleSelectedRemoveImg5 = (data) => {
        setImages5(data);
    };

    const [dataLink, setDataLink] = useState({
        link1: null,
        link2: null,
        link3: null,
        link4: null,
        link5: null,
    });

    const fetchSocialConfig = async () =>  {
        //TODO
        const rs = await getSocialConfig();
        const rsData = rs?.data?.data
      
        const mapImg1 = rsData?.img_social_1 ? [{
                    id: 0,
                    status: false,
                    src:
                    rsData?.img_social_1 === null ||
                    rsData?.img_social_1 === ""
                        ? ''
                        : rsData?.img_social_1,
                    file: rsData?.img_social_1 ? await urlToBlob(rsData?.img_social_1) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
        }] : []

        const mapImg2 = rsData?.img_social_2 ? [{
                    id: 1,
                    status: false,
                    src:
                    rsData?.img_social_2 === null ||
                    rsData?.img_social_2 === ""
                        ? ''
                        : rsData?.img_social_2,
                    file: rsData?.img_social_2 ? await urlToBlob(rsData?.img_social_2) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
        }] : []

        const mapImg3 = rsData?.img_social_3 ? [{
                    id: 2,
                    status: false,
                    src:
                    rsData?.img_social_3 === null ||
                    rsData?.img_social_3 === ""
                        ? ''
                        : rsData?.img_social_3,
                    file: rsData?.img_social_3 ? await urlToBlob(rsData?.img_social_3) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
        }] : []

        const mapImg4 = rsData?.img_social_4 ? [{
                    id: 3,
                    status: false,
                    src:
                    rsData?.img_social_4 === null ||
                    rsData?.img_social_4 === ""
                        ? ''
                        : rsData?.img_social_4,
                    file: rsData?.img_social_4 ? await urlToBlob(rsData?.img_social_4) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
        }] : []


        const mapImg5 = rsData?.img_social_5 ? [{
                    id: 4,
                    status: false,
                    src:
                    rsData?.img_social_5 === null ||
                    rsData?.img_social_5 === ""
                        ? ''
                        : rsData?.img_social_5,
                    file: rsData?.img_social_5 ? await urlToBlob(rsData?.img_social_5) : null,
                    size: 1024*1024*4, //hard code ให้ผ่าน validate 
                    type:'image/jpg' //hard code ให้ผ่าน validate
        }] : []

        setImagesFromApi1(mapImg1)
        setImagesFromApi2(mapImg2)
        setImagesFromApi3(mapImg3)
        setImagesFromApi4(mapImg4)
        setImagesFromApi5(mapImg5)

        setDataLink({
            link1: rsData?.link_social_1,
            link2: rsData?.link_social_2,
            link3: rsData?.link_social_3,
            link4: rsData?.link_social_4,
            link5: rsData?.link_social_5,
        })
    }

    useEffect(() => {
        fetchSocialConfig()
    }, [])

    // const validateOneCorrectLink = async (linkArr) => {
    //     console.log(`=========== validateOneCorrectLink ===========`)
    //     console.log(linkArr)
    //     console.log(linkArr.length)
    //     // linkArr.forEach(item => {
    //     //     console.log(`log item in foreach`,item)
    //     // })
    //     for(let i = 0; i < linkArr.lengh; i++) {
    //         console.log(`i: `,i)
    //         const item = linkArr[i]
    //         console.log(`item link`, item)
    //         if(!isValidHttpUrl(item)) return false
    //     }
    //     return true
    // }

    // const validateOneCorrectLink2 = async (linkArr) => {
    //    return Promise.resolve(async() => {
    //     if(Array.isArray(linkArr)) {
    //         console.log(`array rec`)
    //         linkArr.forEach(item => {
    //             console.log(`log item in foreach`, item)
    //             if(!isValidHttpUrl(item)) return false
    //         })
    //         return true
    //     }else{
    //         console.log(`none arr`)
    //         return false
    //     }
    //    })
    // }


    // const populateLinkBeforeValidate = (body) => {
    //     const arr = []
    //     if(body.link_social_1) arr.push(body.link_social_1)
    //     if(body.link_social_2) arr.push(body.link_social_2)
    //     if(body.link_social_3) arr.push(body.link_social_3)
    //     if(body.link_social_4) arr.push(body.link_social_4)
    //     if(body.link_social_5) arr.push(body.link_social_5)

    //     return arr
      
    // }

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
       
        try {
            const body = {
                link_social_1: dataLink?.link1,
                link_social_2: dataLink?.link2,
                link_social_3: dataLink?.link3, 
                link_social_4: dataLink?.link4,
                link_social_5: dataLink?.link5,
                img_social_1: images1, 
                img_social_2: images2,
                img_social_3: images3,
                img_social_4: images4,
                img_social_5: images5,
            }

            if(!body?.link_social_1 ||
            
                images1.lengh <= 0 
              
            ) {
                await alertValidate();
            }else {
                // console.log(`valid validate form`)
                // if(body.link_social_1) {
                //     if(!isValidHttpUrl(body.link_social_1)) {
                //         console.log(`invalid link 1`)
                //         await alertValidate("กรุณากรอกลิงค์ให้ถูกต้อง");
                //     }
                //     console.log(`done 1`)
                // }else if(body.link_social_2) {
                //     console.log(`body.link_social_2`, body.link_social_2)
                //     if(!isValidHttpUrl(body.link_social_2)) {
                //         console.log(`invalid link 2`)
                //         await alertValidate("กรุณากรอกลิงค์ให้ถูกต้อง");
                //     }
                //     console.log(`done 2`)
                // }else if(body.link_social_3) {
                //     if(!isValidHttpUrl(body.link_social_3)){    
                //         console.log(`invalid link 3`) 
                //         await alertValidate("กรุณากรอกลิงค์ให้ถูกต้อง");
                //     }
                //     console.log(`done 3`)
                // }else if(body.link_social_4) {
                //     if(!isValidHttpUrl(body.link_social_4)) {
                //         console.log(`invalid link 4`) 
                //         await alertValidate("กรุณากรอกลิงค์ให้ถูกต้อง");
                //     }
                //     console.log(`done4 `)
                // }else if(body.link_social_5) {
                //     if(!isValidHttpUrl(body.link_social_5)) {
                //         console.log(`invalid link 5`) 
                //         await alertValidate("กรุณากรอกลิงค์ให้ถูกต้อง");
                //     }
                //     console.log(`done 5`)
                // }else{
                    
                // }

                const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                            (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateSocialConfig(body)
                            setTimeOutSync(() => setLoading(false)).then(async () => {
                                if (response.data.status == "success") {
                                    const result = await alertSaved();
                                    if (result.isConfirmed) {
                                        window.location.reload()
                                    }
                                }
                            }).finally(() => setLoading(false))
                            })();
                        }
            }
        } catch (error) {
            console.log('found error ', error)
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    window.location.reload();
                }
                else { }
    };

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"SOCIAL MEDIA"} />
        <Menu
            parentmenu={"infoSocialMedia"}
            activemenu={"infoSocialMedia"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-social.png" className="ic-user01 me-2" alt="" />
                                SOCIAL MEDIA
                            </font>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col xs={7}>
                            <Row className='align-items-center'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Icon <span className=' colorRed'>*</span></font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages1}
                                            images={imagesFromApi1}
                                            txtDetail={"jpg. / 100x100 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg1}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} className='d-flex align-items-center'>
                            <Row className='align-items-center w-100'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Link Social </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Social"
                                            value={dataLink.link1}
                                            onChange={(event) =>
                                                setDataLink({
                                                    ...dataLink,
                                                    link1: event.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col xs={7}>
                            <Row className='align-items-center'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Icon</font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages2}
                                            images={imagesFromApi2}
                                            txtDetail={"jpg. / 100x100 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg2}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} className='d-flex align-items-center'>
                            <Row className='align-items-center w-100'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Link Social</font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Social"
                                            value={dataLink.link2}
                                            onChange={(event) =>
                                                setDataLink({
                                                    ...dataLink,
                                                    link2: event.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col xs={7}>
                            <Row className='align-items-center'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Icon </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages3}
                                            images={imagesFromApi3}
                                            txtDetail={"jpg. / 100x100 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg3}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} className='d-flex align-items-center'>
                            <Row className='align-items-center w-100'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Link Social </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Social"
                                            value={dataLink.link3}
                                            onChange={(event) =>
                                                setDataLink({
                                                    ...dataLink,
                                                    link3: event.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col xs={7}>
                            <Row className='align-items-center'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Icon </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages4}
                                            images={imagesFromApi4}
                                            txtDetail={"jpg. / 100x100 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg4}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} className='d-flex align-items-center'>
                            <Row className='align-items-center w-100'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Link Social </font>
                                    </div>
                                    <div className='pe-1 w-100 '>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Social"
                                            value={dataLink.link4}
                                            onChange={(event) =>
                                                setDataLink({
                                                    ...dataLink,
                                                    link4: event.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col xs={7}>
                            <Row className='align-items-center'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Icon </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <UploadIMG
                                            limit={1}
                                            onSelectedImages={handleSelectedImages5}
                                            images={imagesFromApi5}
                                            txtDetail={"jpg. / 100x100 px  , limit size 5MB"}
                                            removeImg={handleSelectedRemoveImg5}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={5} className='d-flex align-items-center'>
                            <Row className='align-items-center w-100'>
                                <Col xs={12} className="d-flex flex-row align-items-center">
                                    <div className="w-25">
                                        <font className='fontReg font-size03 colorBlack01'>Link Social </font>
                                    </div>
                                    <div className='pe-1 w-100'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="linkConrad"
                                            placeholder="Link Social"
                                            value={dataLink.link5}
                                            onChange={(event) =>
                                                setDataLink({
                                                    ...dataLink,
                                                    link5: event.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                    <button
                        className="btn-cancle01"
                        onClick={() => handleClickCancel()}
                    >
                        CANCEL
                    </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                    <button
                        className="btn-save01"
                        onClick={(e) => {
                            handleSaveBtn();
                        }}
                    >
                        SAVE
                    </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default SocialMedia